import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProductRoute = ({ product, children }) => {
  const { hasProductAccess } = useAuth();

  if (!hasProductAccess(product)) {
    return <Navigate to="/403" replace />;
  }

  return children;
};

export default ProductRoute;
